import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import Spinner from "../components/Loader/Spinner";
import { Modal, Button } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";

import { allhostellogin, get_year_of_const } from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import axios from "../api/constant";
import {
  subassets,
  getAssetsName,
  AddAsset,
  Assetnameinfo,
  AddHostelRequirement,
  getdistrictName,
  getallDistricts,
  getAmenitiesType,
  getdistictName,
  getAllBlocksFromDistrict,
  getGPFromDistrictAndBlock,
  getVillageFromGpBlockAndDistrict,
  getSchoolFromVillage,
  getAmenityCountsData,
  getGCB,
  update_actual_count,
} from "../api/Users";

const ManageStocks = ({ role, userData }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [AssetsSubTypes, setAssetsSubTypes] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [ExistAssetsType, setExistAssetsType] = useState([]);
  const [markRequired, setMarkRequired] = useState(true);
  const [AssetsType, setAssetsType] = useState("all");
  const [AssetsTypes, setAssetsTypes] = useState([]);
  const [postAmenityName, setPostAmenityName] = useState("");
  const [editReason, setEditReason] = useState('');
  const [error, setError] = useState('');

  const [gbcType, setGcbType] = useState("");
  const [gcb, setGcb] = useState([]);
  const [yearsCons, setYearsCons] = useState([]);
  const [yearCons, setYearCons] = useState("");
  const [hostels, setHostels] = useState([]);
  const [hostelType, setHostelType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [newQuantity, setNewQuantity] = useState(0);

  const handleCloseModal = () => {
    // Logic to close modal
    setModalOpen(false);
  };

  const handleUpdateClick = (row) => {
    setSelectedRow(row);
    setModalOpen(true);
  };

  const handleHostelType = (event) => {
    setHostelType(event.target.value);
  };

  const handleGCBChange = async (e) => {
    setGcbType(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: e.target.value,
    };
    await axios
      .post("/get_year_of_cons_from_gbc_udise", data)
      .then((response) => {
        if (response.data.status == "success") {
          setYearsCons(response.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const handleYear = (e) => {
    setYearCons(e.target.value);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      gbc_id: gbcType,
      yoc: e.target.value,
    };
    console.log(data);
    axios
      .post("/get_hostel_type_from_udise_gbc_yoc", data)
      .then((response) => {
        if (response.data.status == "success") {
          setHostels(response.data.data.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching Categories:", err);
      });
  };

  const AssetTypehandle = async (e) => {
    const selectedValue = e.target.value;
    console.log(selectedValue);

    if (!selectedValue) {
      console.error("Empty value received");
      return;
    }

    try {
      const amenities = JSON.parse(selectedValue);
      console.log(amenities);

      const amenityId = amenities.amenity_id;
      setAssetsType(amenityId);

      const amenityName = amenities.name;
      setPostAmenityName(amenityName);

      console.log("AssetsType", amenityId);

      const response = await subassets({ amenity_id: amenityId });
      if (response) {
        console.log(response.data.asset_name);
        setAssetsSubTypes(response.data.asset_name);
      } else {
        console.error("Invalid response format for subassets:", response);
      }
    } catch (error) {
      console.error("Error fetching subassets:", error);
    }
  };

  useEffect(() => {
    getAmenitiesType()
      .then((res) => {
        if (res.status === "success") {
          console.log("amenities data:", res.data);
          setAssetsTypes(res.data);
          setExistAssetsType(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  useEffect(() => {
    getGCB()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setGcb(res.data.student_gbc_master);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  useEffect(() => {
    getStocksData();
  }, []);

  const getStocksData = () => {
    setIsLoading(true);
    const data = {
      UDISE_code: userData.data.UDISE_code,
      year: yearCons,
      amenity_type: AssetsType,
      hostel_type: hostelType,
    };
    axios
      .post(`/manage_stock`, data)
      .then((response) => {
        if (response.data.status == "success") {
          setFilteredData(response.data.data.result);
          setRows(response.data.data.result);
          setIsLoading(false);
        } else {
          setFilteredData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  };

  // Update filteredData whenever searchQuery changes
  useEffect(() => {
    const filtered = rows.filter(
      (item) =>
        item.hostel_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.school_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.hostel_category
          .toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        (item.UDISE_code &&
          item.UDISE_code.toString()
            .toLowerCase()
            .includes(searchQuery.toLowerCase())) ||
        item.school_catgegory.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setPage(0);
  }, [searchQuery, rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let navigate = useNavigate();
  const view = (id) => {
    navigate(`/${role === 5 ? "dealer" : "admin"}/userdetails/${id}`);
  };

  const handleNewQuantity = (e) => {
    e.target.value > selectedRow.actual_count
      ? toast.error("Modified Qty should not be greater than Actual Qty")
      : console.log("");
    setNewQuantity(e.target.value);
  };
  const handleInputChange = (event) => {
    setEditReason(event.target.value);
    setError('');
  };
  const handleSubmit = (event) => {

    // event.preventDefault();

    // Check if editReason is empty
    if (editReason.trim() === '') {
      setError('Please provide a reason for editing.'); // Set error message
      return;
    }


    setEditReason('');

    console.log(selectedRow);
    let data = {
      amenities_id: selectedRow.amenities_id,
      actual_count: newQuantity,
      amenities_sub_type_id: selectedRow.amenities_sub_type_id,
      UDISE_code: userData.data.UDISE_code,
    };
    update_actual_count(data).then((res) => {
      if (res.status == "success") {
        toast.success(res.message);
        window.location.reload();
      }
    });
    // update_actual_count
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-0 px-md-3">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h5 className="mt-4">{t("Manage Stock")}</h5>
          <div className="mb-3">
            <TextField
              label={t("Search")}
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state with the new value
              InputProps={{
                endAdornment: <SearchIcon />,
              }}
              style={{
                width: "17rem",
                marginTop: "20px", // Additional style from your existing code
              }}
            />
          </div>
        </div>
        <div className="d-flex col-12 justify-content-start align-items-center">
          <div className="col-md-2 mt-3">
            <label className="form-label">
              {t("GBC Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="gbc_type"
              value={gbcType}
              className="common-input form-select"
              onChange={handleGCBChange}
              required
            >
              <option value="">{t("Select GBC Type")}</option>
              {gcb.map((item) => (
                <option value={item.id}>{t(item.type)}</option>
              ))}
            </select>
          </div>

          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Year of Construction")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="yearCons"
              className="common-input form-select"
              value={yearCons}
              onChange={handleYear}
              required
            >
              <option value="">{t("Year of Construction")}</option>
              {yearsCons.map((item) => (
                <option value={item.year_of_const}>
                  {t(item.year_of_const)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Hostel Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="hostelType"
              className="common-input form-select"
              value={hostelType}
              onChange={handleHostelType}
              required
            >
              <option value="">{t("Select Hostel Type")}</option>
              {hostels.map((item) => (
                <option value={item.hostel_type}>{t(item.hostel_type)}</option>
              ))}
            </select>
          </div>
          <div className="col-md-2 mt-3" style={{ marginLeft: "2rem" }}>
            <label className="form-label">
              {t("Amenity Type")}{" "}
              {markRequired && <span style={{ color: "red" }}>*</span>}
            </label>
            <select
              name="asset_type_id"
              className="common-input form-select"
              onChange={AssetTypehandle}
              required
            >
              <option value="all">{t("Select Amenity Type")}</option>
              {/* Map assetOptions to generate option elements */}
              {AssetsTypes.assets_name &&
                AssetsTypes.assets_name.map((row, index) => (
                  <option key={index} value={JSON.stringify(row)}>
                    {row.name}
                  </option>
                ))}
            </select>
          </div>
          <button
            className="btn btn-primary btn-sm mx-5"
            style={{ marginTop: "45px" }}
            onClick={getStocksData}
          >
            {t("Search")}
          </button>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">{t("Sr. No.")}</TableCell>
                  <TableCell align="center">{t("Amenity Type")}</TableCell>
                  <TableCell align="center">{t("Amenity Sub Type")}</TableCell>
                  <TableCell align="center">{t("Ideal Count")}</TableCell>
                  <TableCell align="center">{t("Actual Count")}</TableCell>
                  <TableCell align="center">{t("Shortage Count")}</TableCell>
                  <TableCell align="left">{t("Action")}</TableCell>
                </TableRow>
              </TableHead>

              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row" align="center">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center">
                          {row.amenities_type}
                        </TableCell>
                        <TableCell align="center">
                          {row.amenities_sub_type_name}
                        </TableCell>
                        <TableCell align="center">{row.ideal_count}</TableCell>
                        <TableCell align="center">{row.actual_count}</TableCell>
                        <TableCell align="center">
                          {row.shortage_count}
                        </TableCell>
                        <TableCell align="left">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleUpdateClick(row)}
                          >
                            {t("Edit")}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableRow>
                  <TableCell align="center" colSpan={7}>
                    <h4>
                      {" "}
                      <i>{t("No data available")}</i>{" "}
                    </h4>
                  </TableCell>
                </TableRow>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
        {selectedRow && (
          <Modal
            open={modalOpen}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 580,
                backgroundColor: "#ffffff",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 8,
                padding: 20,
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-5">
                <div>
                  <MDBTypography tag="h5" className="mb-4">
                    Edit Actual Quantity
                  </MDBTypography>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">{t("Ideal Quantity")}</label>
                  <input
                    type="text"
                    name="ideal_count"
                    defaultValue={selectedRow.ideal_count}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">{t("Actual Quantity")}</label>
                  <input
                    type="text"
                    name="actual_count"
                    defaultValue={selectedRow.actual_count}
                    className="form-control"
                    disabled
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    {t("New Actual Quantity")}
                  </label>
                  <input
                    type="text"
                    name="actual_count"
                    defaultValue={selectedRow.actual_count}
                    className="form-control"
                    onChange={handleNewQuantity}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    {t("Reason for Updation")}
                  </label>
                  <input
                    type="text"
                    id="editReason"
                    name="editreason"
                    className={`form-control ${error ? "is-invalid" : ""}`}
                    value={editReason}
                    onChange={handleInputChange}
                    required
                  />
                  {error && <div className="invalid-feedback">{error}</div>}
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-primary mx-1 mt-4 btn-sm col-2"
                  onClick={handleSubmit}
                >
                  {t("Submit")}
                </button>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    background: "none",
                    border: "none",
                    fontSize: 24,
                    cursor: "pointer",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    className="bi bi-x"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                  </svg>
                </button>
                {/* <button
                  className="btn btn-danger mx-1 mt-4 btn-sm col-2"
                  onClick={handleCloseModal}
                >
                  Close
                </button> */}
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ManageStocks;
